/* eslint-disable no-shadow */
import { STRINGS } from 'config';

export const initialState = {
  devNHSLogin: `{
    "given_name": "Josh",
    "gp_registration_details": {
      "gp_ods_code": "B85036"
    },
    "nhs_number": "0123456789",
    "family_name": "Butterworth",
    "birthdate": "1985-12-23",
    "phone_number": "01234 123 456",
    "email": "josh.butterworth@webgp.com"
  }`,
  patientDetails: {},
  isVerified: false,
  isLoggedIn: false,
  TEST_CODE: '',
};

const login = STRINGS.LOGIN_REDUCER;

export const loginReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case login.UPDATE_DEV_LOGIN:
      return { ...state, devNHSLogin: action.payload };
    case login.UPDATE_LOGIN_STATUS:
      return {
        ...state,
        patientDetails: action.payload.patientDetails,
        isVerified: action.payload.isVerified,
        isLoggedIn: action.payload.isLoggedIn,
        error: action.payload.error,
        error_description: action.payload.error_description,
      };
    case login.SET_TEST_CODE:
      return { ...state, TEST_CODE: action.payload };
    case STRINGS.SESSION_REDUCER.RESTART_SESSION:
      return { ...initialState };
    default:
      return state;
  }
};
